'use client';

import React, { useState, useEffect } from "react";
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Divider from '@mui/material/Divider';
import axios from "axios";
import Select from 'react-select';
import { useNavigate } from "react-router-dom";
import { FaRegCheckCircle, FaRegTimesCircle } from "react-icons/fa";
import { useToast } from "../ui/ToastContext";
import { useLocation } from "react-router-dom";
import { API_URL } from "../../config"; { }

export function ProducerEditForm(): React.JSX.Element {
    const { showToast } = useToast();
    const navigate = useNavigate();
    const location = useLocation();
    const { item: initialData } = location.state || {}; // Obține datele inițiale
    const [selectedEdit, setSelectedEdit] = useState(initialData);
    const [userData, setUserData] = useState([]);
    const [Nume_prenume, setNume_prenume] = useState(initialData?.producer_name || "");
    const [valueuser, setValueuser] = React.useState<OptionUser[] | null>(null);
    const [nameError, setnameError] = useState(false);
    const [logError, setlogError] = useState(false);
    const [Data1, setData1] = useState([]);
    const [isActive, setIsActive] = useState(initialData?.is_active);
    const [showGrid, setShowGrid] = useState(true); // Stare pentru a controla ce să afișezi
    const getJwtFromCookies = () => {
        const cookies = document.cookie.split("; ");
        const tokenCookie = cookies.find(row => row.startsWith("accessToken="));
        return tokenCookie ? tokenCookie.split("=")[1] : null;
    };
    //const token = getJwtFromCookies();

    const token = localStorage.getItem('jwtToken');


    useEffect(() => {
        const timer = setTimeout(() => {
            setShowGrid(false); // După 1 secundă, comutăm pe grid
        }, 1000);
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        axios
            .get(`${API_URL}/api/repprod`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setUserData(response.data)
                // ////////////////////////////////console.log(response.data)
            })
            .catch((error) => {
                console.error("Error fetching user data:", error);

            });
    }, []);

    useEffect(() => {
        axios
            .get(`${API_URL}/api/repprod`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setData1(response.data)
                // ////////////////////////////////console.log(response.data)
            })
            .catch((error) => {
                console.error("Error fetching user data:", error);

            });
    }, []);

    useEffect(() => {
        // Setează valorile implicite din selectedEdit
        if (selectedEdit) {
            const defaultRegion = Data1.find((r: OptionUser) => r.producer_group_id === selectedEdit.producer_group_id);
            setValueuser(defaultRegion || null);
        }
    }, [selectedEdit, Data1]);

    interface OptionUser {
        producer_group_id: number;
        producer_group_name: string;
    }

    const organizerOptionsuser: OptionUser[] = userData.map((role: OptionUser) => ({
        producer_group_id: role.producer_group_id,
        producer_group_name: role.producer_group_name,
    }));

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (Nume_prenume === "" || (!valueuser && !selectedEdit)) {
            setnameError(Nume_prenume === "" ? true : false);
            setlogError(!valueuser || valueuser?.length === 0 ? true : false);
            return;
        }

        try {
            const groupsToSubmit = valueuser && valueuser.length > 0
                ? valueuser
                : [{ producer_group_id: selectedEdit.producer_group_id }];

            for (let producerId1 of groupsToSubmit) {
                await axios.put(`${API_URL}/api/changeproducer/${selectedEdit.producer_id}`, {
                    producer_name: Nume_prenume,
                    producer_group_id: producerId1.producer_group_id,
                    is_active: isActive ? 1 : 0,
                });
            }

            handleClose();
            showToast({
                message: "Datele au fost salvate cu succes!",
                type: "success",
                icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
            });
        } catch (error) {
            console.error(error);
            showToast({
                message: "Eroare la inserarea datelor!",
                type: "error",
                icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
            });
        }
    };

    const handleClose = () => {
        navigate(-1); // Use navigate to go back
    };

    const handleChange = (e) => {
        setNume_prenume(e.target.value);
    };

    const handleClick = () => {
        setIsActive(!isActive);
    }

    const isDarkMode = document.documentElement.classList.contains('dark');

    return (
        <div > {showGrid ? (
            <div className="flex flex-row gap-2">
                <div className="animate-pulse bg-gray-300 w-14 h-14 rounded-lg"></div>
                <div className="flex flex-col gap-2">
                    <div className="animate-pulse bg-gray-300 w-28 h-5 rounded-lg"></div>
                    <div className="animate-pulse bg-gray-300 w-36 h-3 rounded-lg"></div>
                    <div className="animate-pulse bg-gray-300 w-36 h-2 rounded-lg"></div>
                </div>
            </div>
        ) : (
            <form
                onSubmit={(event) => {
                    event.preventDefault();
                }}
            >
                <Card className="p-2 dark:bg-gray-800 dark:text-gray-100">
                    <CardHeader
                        subheader="Informatia poate fii modificata"
                        title="Formular"
                        subheaderTypographyProps={{
                            style: { fontSize: "0.875rem", color: "#B0B0B0" },
                        }}
                        action={
                            <button
                                className={`px-4 py-2 rounded-md text-sm font-semibold mr-2 ${isActive === true
                                    ? "bg-green-700 text-white"
                                    : "bg-gray-500 text-white"
                                    }`}
                                onClick={handleClick}
                            >
                                {isActive === true ? "Activ" : "Inactiv"}
                            </button>
                        }
                    />
                    <Divider className="dark:bg-gray-400" />
                    <CardContent>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                            <div className="relative">
                                <label
                                    className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 dark:text-gray-100"
                                >
                                    Denumirea
                                </label>
                                <input
                                    className={`w-full p-3 border rounded-md dark:bg-gray-800 dark:text-gray-100 ${nameError ? 'border-red-500' : ''}`}
                                    type="text"
                                    name="firstName"
                                    placeholder="Denumirea"
                                    value={Nume_prenume}
                                    onChange={handleChange}

                                />
                                {nameError && <p className="text-red-500 text-sm">Denumirea este obligatorie.</p>}

                            </div>

                            <div className="relative">
                                <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 z-10dark:text-gray-100 z-10" >
                                    Grup de producatori
                                </label>
                                <Select
                                    options={organizerOptionsuser}
                                    placeholder="Selecteaza..."
                                    classNamePrefix="react-select"
                                    value={valueuser}
                                    onChange={(selected) => {
                                        //////////////////////////////console.log("Selected value:", selected);
                                        setValueuser(selected ? [selected] : null); // Asigură-te că value este întotdeauna un array
                                    }}

                                    getOptionLabel={(e) => e.producer_group_name}
                                    getOptionValue={(e) => String(e.producer_group_id)}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            width: '100%',
                                            padding: '0.5rem',
                                            borderRadius: '0.375rem',
                                            borderColor: logError ? 'red' : '#424242',
                                            boxShadow: 'none',
                                            height: '3rem',
                                            color: isDarkMode ? '#FFFFFF' : '#1F2937',
                                            backgroundColor: isDarkMode ? '#1f2937' : provided.backgroundColor,
                                        }),
                                        menuPortal: (base) => ({
                                            ...base,
                                            zIndex: 9999, // Z-index mare pentru a depăși dialogul
                                            color: isDarkMode ? 'black' : base.backgroundColor,
                                        }),
                                        singleValue: provided => ({
                                            ...provided,
                                            color: isDarkMode ? '#FFFFFF' : '#1F2937',
                                        })
                                    }}
                                />
                                {logError && <p className="text-red-500 text-sm">Grupul de producatori este obligatoriu.</p>}

                            </div>
                        </div>
                    </CardContent>
                    <Divider className="dark:bg-gray-400" />
                    <CardActions sx={{ justifyContent: 'flex-end' }}>
                        <button className="btn bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white" onClick={handleSubmit}>
                            <svg className="fill-current shrink-0 xs:hidden" width="16" height="16" viewBox="0 0 16 16">
                                <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                            </svg>
                            <span className="//max-xs:sr-only">Salveaza detaliile</span>

                        </button>
                    </CardActions>
                </Card>
            </form>
        )}
        </div>
    );
}
